import RichTextProvider from './hooks/useRichText';

import { RichTextProps } from './@types/RichTextProps';
import RichTextContainer from './handles/RichTextContainer';

import './RichText.scss';

const RichText = (props: RichTextProps) => (
	<RichTextProvider {...props}>
		<RichTextContainer />
	</RichTextProvider>
);

export default RichText;
